import privateRoutes from "./routes";

export default privateRoutes;
